<template>
    <span>
        <InputNumber v-model="val" @on-change="changed" size="small"
        :min="min" :max="max" :step="step" :precision="precision"></InputNumber>
        <template v-if="units">
            <Select v-if="units.length>1" v-model="unit" @on-change="changed" style="width:auto" size="small" >
                <Option v-for="item in units" :key="item.value" :value="item.value">{{item.label}}</Option>
            </Select>
            <span v-else-if="units.length===1">{{units[0].label}}</span>
        </template>
    </span>
</template>
<script>
    export default {
        name: 'de-number-prop',
        props: {
            value: {
                type: Object
            },
            min: {
                type: Number,
                default: -Infinity
            },
            max: {
                type: Number,
                default: Infinity
            }, 
            step: {
                type: Number,
            }, 
            precision: {
                type: Number
            },
            units:{
                type:Array
            }
        },
        data() {
            return {
                val: 0,
                unit:''
            }
        },
        watch: {
            value: {
                handler(value) {
                    this.val = value.value;
                    this.unit = value.unit;
                },
                immediate: true
            }
        },
        methods: {
            changed() {
                if(!this.unit){
                    this.unit  = this.units[0];
                }
                this.$emit("input", {value:this.val, unit:this.unit})
                this.$emit('save')
            }
        }
    }
</script>